import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SearchButton = styled(Button)(({ theme }) => ({
  width: 156,
  height: 25,
  fontSize: theme.typography.pxToRem(12),
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.text.secondary,
  lineHeight: 1,
  border: `1px solid ${theme.palette.grayscale[500]}`,
  borderRadius: 5,
  justifyContent: 'start',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  textTransform: 'none',
  '& .MuiButton-startIcon': {
    color: theme.palette.primary.main,
  },
  '&:focus': {
    outline: '2px solid',
    outlineColor: theme.palette.primary.main,
    outlineOffset: 2,
  },
}));
